import React from "react";

import { ReactComponent as Loader } from "../../../assets/icons/loader.svg";
import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogActions,
  StyledButton
} from "./styled";

export const ConfirmDialog = ({
  title = "Are you sure?",
  message,
  handleClose,
  isOpen,
  handleConfirm,
  cancelLabel = "Cancel",
  confirmLabel = "Yes, I'm sure",
  divider = true,
  isDisplayBtnLoader = false,
  disableBackdropClick,
  disableEscapeKeyDown,
  className
}) => {
  /* istanbul ignore next */
  const onClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return false;
    }

    if (disableEscapeKeyDown && reason === "escapeKeyDown") {
      return false;
    }

    if (typeof handleClose === "function") {
      handleClose();
    }
  };

  return (
    <StyledDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="draggable-dialog-title"
      classes={{
        container: className,
        paper: title !== null ? "paper" : "noTitlePaper"
      }}
      data-testid="confirm-dialog"
    >
      {title !== null && (
        <StyledDialogTitle className="title" id="draggable-dialog-title">
          {title}
        </StyledDialogTitle>
      )}
      <StyledDialogContent>{message}</StyledDialogContent>
      {divider && <div className="divider" />}
      {(handleClose || handleConfirm) && (
        <StyledDialogActions>
          {handleClose && (
            <StyledButton
              onClick={handleClose}
              color="primary"
              variant="outlined"
              disabled={isDisplayBtnLoader}
              data-testid="cancelButton"
            >
              {cancelLabel}
            </StyledButton>
          )}
          {handleConfirm && (
            <StyledButton
              onClick={handleConfirm}
              color="primary"
              variant="contained"
              className="marginTop12"
              data-testid="confirmButton"
            >
              {isDisplayBtnLoader ? (
                <Loader data-testid="confirm-dialog-loader" className="loader" alt="loading" />
              ) : (
                confirmLabel
              )}
            </StyledButton>
          )}
        </StyledDialogActions>
      )}
    </StyledDialog>
  );
};
